import React from 'react';
import season_logo from '../images/Heresy_Logo_EN_NoAct.png';

export default props => {
    return (
        <img class="destiny_image" src={season_logo}/>
    );
  };